import { useGetProductionsDetailsQuery, useGetProductionsQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'

export const useReservationProductions = (propertyId: string, reservationId: string, reservedResourceId?: string) => {
  const { id: tenantId } = useTenant()
  const { data: dataProductions, loading: loadingProductions } = useGetProductionsQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: { eq: propertyId },
        id: reservedResourceId ? { eq: reservedResourceId } : undefined,
        reservationId: !reservedResourceId ? { eq: reservationId } : undefined,
      },
    },
  })

  const { loading: loadingProductionsDetail, refetch: refetchProductionsDetail } = useGetProductionsDetailsQuery({ skip: true })

  return { dataProductions, loadingProductions, loadingProductionsDetail, refetchProductionsDetail }
}
